<div class="nplPage priceListPageClass-wrapper" style="text-align: center; width: 80%;">
  <!-- Terms and Conditions -->
  <div class="edlp-terms-banner" *ngIf="termsConditions?.trim()">
    <div class="edlp-terms">
      <div class="edlp-terms__label">Terms and Conditions</div>
      <div class="edlp-terms__content">
       {{ termsConditions}}
      </div>
    </div>
  </div>

  <!-- AC2: Page header -->
  <div class="page-heading">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="text-left">WinField United Prop HIF Price Sheet</h5>
       <!-- AC2: Last Refresh Date -->
      <div class="middleSection" *ngIf="selectedAccount && isPricingReady">
        <div class="col-md-12 padding-l30 padding-b10 padding-t10">
          <div class="row">
            <div class="col-md-12 text-right">
              <div class="subscribe-sec edlp-subscribe-sec">
                <div class="status">
                  MY STATUS
                  <span *ngIf="isStatus == 'Subscribed'" class="subscribeColor" (click)="showHideSubscription()">{{ isStatus }}</span>
                  <span *ngIf="isStatus != 'Subscribed'" class="unSubscribeColor" (click)="showHideSubscription()">NOT SUBSCRIBED</span>
                </div>
                <div class="tab-content" *ngIf="isSubsModalShow" appClickOutside (clickOutside)="closePopup()">
                  <div class="salesPersonOuter edlp-subscription-popup">
                    <div class="tab-content-heading headtabPadding">
                      For: <span class="account-name">{{ selectedAccountName }}</span>
                    </div>
                    <div class="tab-content-detail">
                      <p>
                        <ng-container *ngIf="isStatus == 'Subscribed'; else subscribeText">
                          Do you want to <span class="edlp-unsubscribe-text">UNSUBSCRIBE</span> to this WU Prop HIF Price Sheet?
                        </ng-container>
                        <ng-template #subscribeText>
                          Do you want to <span class="edlp-subscribe-text">SUBSCRIBE</span> to this WU Prop HIF Price Sheet?
                        </ng-template>
                      </p>
                      <div class="btn-sec margin-t20">
                        <button mat-raised-button class="btns normal-large-btn margin-r15"
                                (click)="changeStatus()"
                                [disabled]="isSubscriptionBusy"
                                color="primary">{{isStatus == 'Subscribed' ? 'Unsubscribe' : 'Subscribe'}}</button>
                        <button mat-raised-button class="btns normal-large-btn"
                                (click)="closePopup()"
                                [disabled]="isSubscriptionBusy"
                                color="primary">Cancel</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="mb-0 ">Last Refresh Date: <span>{{lastRefreshDate | date:'MM/dd/yyyy'}}</span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="nplPage priceListPageClass-wrapper" style="width: 100%; margin:0;">
    <div class="priceLists margin-0">

      <!-- AC3 & AC8: Sold-To selector row -->
      <div class="topSection">
        <div class="alignTopSec">
          <div class="form-sec">
            <div class="col-sm-12 col-md-12 col-lg-12 smallPadRgt0 padding-l0 mt-2">
              <div class="row search-box-outer">
                <!-- Sold-To dropdown -->
                <div class="col-3 padding-r30">
                  <div class="category-dropdown material-select soldToSelect">
                    <ng-select [items]="eligibleAccounts"
                               [closeOnSelect]="true"
                               [clearable]="true"
                               labelForId="soldTo"
                               [multiple]="false"
                               placeholder="Sold To:"
                               [(ngModel)]="selectedAccount"
                               (change)="onAccountChange()"
                               bindValue="accountNumber"
                               [searchFn]="handleAccountSearch"
                               [keyDownFn]="handleKeyevent">
                      <ng-template ng-label-tmp let-item="item">
                        <span style="display: block;">{{item.accountName}}</span>
                        <span style="display: block;">Account : {{item.accountNumber}}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span style="display: block;">{{item.accountName}}</span>
                        <span style="display: block;">Account : {{item.accountNumber}}</span>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- AC7 & AC9: Filters row + Export -->
      <div class="topSection edlp-filter-section" *ngIf="selectedAccount && isPricingReady">
        <div class="alignTopSec">
          <div class="form-sec">
            <div class="col-sm-12 col-md-12 col-lg-12 smallPadRgt0 padding-l0">
              <div class="row search-box-outer">
                <!-- Product Brand filter (ng-select multi) -->
                <div class="col-3 padding-r30">
                  <div class="category-dropdown material-select edlp-filter-select">
                    <ng-select [items]="filteredProductBrands"
                               [multiple]="true"
                               [closeOnSelect]="false"
                               [clearable]="false"
                               [searchable]="false"
                               bindLabel="productBrand"
                               bindValue="productBrand"
                               placeholder="Product Brand"
                               [(ngModel)]="searchProductBrand"
                               (change)="onBrandSelectionChange()"
                               [keyDownFn]="handleKeyevent"
                               (open)="onBrandPanelOpen()"
                               (close)="onBrandPanelClose()"
                               dropdownPosition="bottom">
                      <ng-template ng-multi-label-tmp let-items="items">
                        <span class="edlp-ng-select-label" *ngIf="items.length === productBrandData.length">All Product Brands</span>
                        <span class="edlp-ng-select-label" *ngIf="items.length > 0 && items.length < productBrandData.length">{{items.length}} Brand(s) selected</span>
                      </ng-template>
                      <ng-template ng-header-tmp>
                        <div class="edlp-dd-search">
                          <span class="edlp-dd-search-icon">
                            <i class="fas fa-search" aria-hidden="true"></i>
                          </span>
                          <input type="text" class="edlp-dd-search-input" placeholder="Search..."
                                 [(ngModel)]="brandSearchText" (ngModelChange)="updateFilteredProductBrands()" (click)="$event.stopPropagation()" />
                          <button type="button" class="edlp-dd-search-clear" *ngIf="brandSearchText"
                                  (click)="clearBrandSearch($event)" aria-label="Clear search">
                            <i class="fas fa-times" aria-hidden="true"></i>
                          </button>
                        </div>
                        <div class="edlp-select-all-row" (click)="toggleSelectAllBrands()">
                          <span class="edlp-custom-check" [class.edlp-custom-check--on]="allBrandsSelected()"></span>
                          <span>Select All</span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$">
                        <span class="edlp-custom-check" [class.edlp-custom-check--on]="item$.selected"></span>
                        <span class="edlp-option-label">{{ item.productBrand }}</span>
                      </ng-template>
                      <ng-template ng-footer-tmp>
                        <div class="edlp-dd-footer">
                          <button type="button" class="edlp-dd-clear-all" (click)="clearAllBrands()">Clear All</button>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <!-- Active Ingredient filter (ng-select multi) -->
                <div class="col-3 padding-r30">
                  <div class="category-dropdown material-select edlp-filter-select">
                    <ng-select [items]="filteredActiveIngredients"
                               [multiple]="true"
                               [closeOnSelect]="false"
                               [clearable]="false"
                               [searchable]="false"
                               bindLabel="activeIngredients"
                               bindValue="activeIngredients"
                               placeholder="Active Ingredients"
                               [(ngModel)]="searchActiveIngredient"
                               (change)="onActiveIngredientSelectionChange()"
                               [keyDownFn]="handleKeyevent"
                               (open)="onActiveIngredientPanelOpen()"
                               (close)="onActiveIngredientPanelClose()"
                               dropdownPosition="bottom">
                      <ng-template ng-multi-label-tmp let-items="items">
                        <span class="edlp-ng-select-label" *ngIf="items.length === activeIngredientData.length">All Active Ingredients</span>
                        <span class="edlp-ng-select-label" *ngIf="items.length > 0 && items.length < activeIngredientData.length">{{items.length}} Ingredient(s) selected</span>
                      </ng-template>
                      <ng-template ng-header-tmp>
                        <div class="edlp-dd-search">
                          <span class="edlp-dd-search-icon">
                            <i class="fas fa-search" aria-hidden="true"></i>
                          </span>
                          <input type="text" class="edlp-dd-search-input" placeholder="Search..."
                                 [(ngModel)]="activeIngredientSearchText" (ngModelChange)="updateFilteredActiveIngredients()" (click)="$event.stopPropagation()" />
                          <button type="button" class="edlp-dd-search-clear" *ngIf="activeIngredientSearchText"
                                  (click)="clearActiveIngredientSearch($event)" aria-label="Clear search">
                            <i class="fas fa-times" aria-hidden="true"></i>
                          </button>
                        </div>
                        <div class="edlp-select-all-row" (click)="toggleSelectAllActiveIngredients()">
                          <span class="edlp-custom-check" [class.edlp-custom-check--on]="allActiveIngredientsSelected()"></span>
                          <span>Select All</span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$">
                        <span class="edlp-custom-check" [class.edlp-custom-check--on]="item$.selected"></span>
                        <span class="edlp-option-label">{{ item.activeIngredients }}</span>
                      </ng-template>
                      <ng-template ng-footer-tmp>
                        <div class="edlp-dd-footer">
                          <button type="button" class="edlp-dd-clear-all" (click)="clearAllActiveIngredients()">Clear All</button>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <!-- Export button -->
                <div class="col-6 search-btn text-right m-auto">
                  <button mat-raised-button class="btns" color="primary" (click)="onExportBtnClick()"
                          [disabled]="!FilteredData || FilteredData.length === 0">Export to Excel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- AC3: No account selected message -->
      <div class="bottomSection" *ngIf="!selectedAccount && isPricingReady && !isLoading">
        <div class="noDataMsg">
          <p>Select an account to see the WinField United Prop HIF Price Sheet.</p>
        </div>
      </div>

      <!-- AC4: No data / not published message -->
      <div class="bottomSection" *ngIf="!isPricingReady && !isLoading">
        <div class="noDataMsg">
          <p>{{noDataMessage}}</p>
        </div>
      </div>

      <!-- AC5 & AC6: Grid grouped by Product Brand -->
      <div class="bottomSection" *ngIf="selectedAccount && isPricingReady">
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer priceListTable edlp-grid" id="EDLPPricing">
              <ng-container *ngIf="FilteredData && FilteredData.length > 0; else noGridData">
                <table mat-table [dataSource]="FilteredData" class="matTables edlp-fixed-table">
                  <ng-container matColumnDef="itemNumber">
                    <th mat-header-cell *matHeaderCellDef> Item Number </th>
                    <td mat-cell *matCellDef="let element"> {{element.itemNumber}} </td>
                  </ng-container>
                  <ng-container matColumnDef="itemDescription">
                    <th mat-header-cell *matHeaderCellDef> Item Description </th>
                    <td mat-cell *matCellDef="let element"> {{element.itemDescription}} </td>
                  </ng-container>
                  <ng-container matColumnDef="activeIngredients">
                    <th mat-header-cell *matHeaderCellDef> Active Ingredient </th>
                    <td mat-cell *matCellDef="let element"> {{element.activeIngredients}} </td>
                  </ng-container>
                  <ng-container matColumnDef="productBrand">
                    <th mat-header-cell *matHeaderCellDef> Product Brand </th>
                    <td mat-cell *matCellDef="let element"> {{element.productBrand}} </td>
                  </ng-container>
                  <ng-container matColumnDef="packSize">
                    <th mat-header-cell *matHeaderCellDef> Pack Size </th>
                    <td mat-cell *matCellDef="let element"> {{element.packSize}} </td>
                  </ng-container>
                  <ng-container matColumnDef="uom">
                    <th mat-header-cell *matHeaderCellDef> UOM </th>
                    <td mat-cell *matCellDef="let element"> {{element.uom}} </td>
                  </ng-container>
                  <ng-container matColumnDef="basePriceWithFreight">
                    <th mat-header-cell *matHeaderCellDef> Price </th>
                    <td mat-cell *matCellDef="let element"> {{element.basePriceWithFreight | currency}} </td>
                  </ng-container>
                  <ng-container matColumnDef="midVolumePrice">
                    <th mat-header-cell *matHeaderCellDef> Mid Volume Price </th>
                    <td mat-cell *matCellDef="let element"> {{element.midVolumePrice | currency}} </td>
                  </ng-container>
                  <ng-container matColumnDef="maxVolumePrice">
                    <th mat-header-cell *matHeaderCellDef> Max Volume Price </th>
                    <td mat-cell *matCellDef="let element"> {{element.maxVolumePrice | currency}} </td>
                  </ng-container>
                  <ng-container matColumnDef="midVolumeQty">
                    <th mat-header-cell *matHeaderCellDef> Mid Volume Quantity </th>
                    <td mat-cell *matCellDef="let element"> {{element.midVolumeQty}} </td>
                  </ng-container>
                  <ng-container matColumnDef="maxVolumeQty">
                    <th mat-header-cell *matHeaderCellDef> Max Volume Quantity </th>
                    <td mat-cell *matCellDef="let element"> {{element.maxVolumeQty}} </td>
                  </ng-container>
                  <ng-container matColumnDef="paymentTermsDescription">
                    <th mat-header-cell *matHeaderCellDef> Payment Terms </th>
                    <td mat-cell *matCellDef="let element"> {{element.paymentTermsDescription}} </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"
                      [ngClass]="{'edlp-row-even': row._brandIndex % 2 === 0, 'edlp-row-odd': row._brandIndex % 2 !== 0}"></tr>
                </table>
              </ng-container>
              <ng-template #noGridData>
                <div class="noDataMsg">
                  <p>{{noDataMessage || 'No WinField United Prop HIF Price Sheet is available for the selected account and filters. Please adjust your filters or try again later'}}</p>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

